import doubleDropdown from '../../components/other/NDoubleDropdown/doubleDropdown';
import tripleDropdown from '../../components/other/NTripleDropdown/tripleDropdown';
import Dropdown from '../../components/other/NDropdown/Dropdown';
import Tabs from '../../components/other/NTabsNew/Tabs';
import NewTabs from '../../components/other/NLineTabsSec/LineTabs';
import Api from '../../requests/Api';
import 'swiper/css';
import 'swiper/css/pagination';
import './financeDoc.scss';

(function () {
	const $Api = new Api();
	let portfeles = [
		{
			"id": 1,
			"name": "UDS1-69",
			"created_at": 1739974250,
			"updated_at": 1739974250
		},
		{
			"id": 2,
			"name": "UDS2-69",
			"created_at": 1739974250,
			"updated_at": 1739974250
		},
		{
			"id": 3,
			"name": "UDS3-69",
			"created_at": 1739974250,
			"updated_at": 1739974250
		}
	]
	let params = {
		"2023": [
			{
				"id": 1,
				"portfolio_id": 1,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974252,
				"year": "2025",
				"quotesDate": "2025-02-12",
				"quote": "1000000.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-4.260140052",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974253,
				"updated_at": 1739974259
			},
			{
				"id": 2,
				"portfolio_id": 1,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974256,
				"year": "2025",
				"quotesDate": "2025-02-11",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 3,
				"portfolio_id": 1,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974254,
				"year": "2025",
				"quotesDate": "2025-02-10",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 1,
				"portfolio_id": 2,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974252,
				"year": "2025",
				"quotesDate": "2025-02-12",
				"quote": "1000000.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-4.260140052",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974253,
				"updated_at": 1739974259
			},
			{
				"id": 2,
				"portfolio_id": 2,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974256,
				"year": "2025",
				"quotesDate": "2025-02-11",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 3,
				"portfolio_id": 2,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974254,
				"year": "2025",
				"quotesDate": "2025-02-10",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 1,
				"portfolio_id": 3,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974252,
				"year": "2025",
				"quotesDate": "2025-02-12",
				"quote": "1000000.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-4.260140052",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974253,
				"updated_at": 1739974259
			},
			{
				"id": 2,
				"portfolio_id": 3,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974256,
				"year": "2025",
				"quotesDate": "2025-02-11",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 3,
				"portfolio_id": 3,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974254,
				"year": "2025",
				"quotesDate": "2025-02-10",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			}
		],
		"2024": [
			{
				"id": 1,
				"portfolio_id": 1,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974252,
				"year": "2025",
				"quotesDate": "2025-02-12",
				"quote": "1000000.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-4.260140052",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974253,
				"updated_at": 1739974259
			},
			{
				"id": 2,
				"portfolio_id": 1,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974256,
				"year": "2025",
				"quotesDate": "2025-02-11",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 3,
				"portfolio_id": 1,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974254,
				"year": "2025",
				"quotesDate": "2025-02-10",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 1,
				"portfolio_id": 2,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974252,
				"year": "2025",
				"quotesDate": "2025-02-12",
				"quote": "1000000.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-4.260140052",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974253,
				"updated_at": 1739974259
			},
			{
				"id": 2,
				"portfolio_id": 2,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974256,
				"year": "2025",
				"quotesDate": "2025-02-11",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 3,
				"portfolio_id": 2,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974254,
				"year": "2025",
				"quotesDate": "2025-02-10",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 1,
				"portfolio_id": 3,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974252,
				"year": "2025",
				"quotesDate": "2025-02-12",
				"quote": "1000000.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-4.260140052",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974253,
				"updated_at": 1739974259
			},
			{
				"id": 2,
				"portfolio_id": 3,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974256,
				"year": "2025",
				"quotesDate": "2025-02-11",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 3,
				"portfolio_id": 3,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974254,
				"year": "2025",
				"quotesDate": "2025-02-10",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
		],
		"2025": [
			{
				"id": 1,
				"portfolio_id": 1,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974252,
				"year": "2025",
				"quotesDate": "2025-02-12",
				"quote": "1000000.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-4.260140052",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974253,
				"updated_at": 1739974259
			},
			{
				"id": 2,
				"portfolio_id": 1,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974256,
				"year": "2025",
				"quotesDate": "2025-02-11",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 3,
				"portfolio_id": 1,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974254,
				"year": "2025",
				"quotesDate": "2025-02-10",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 1,
				"portfolio_id": 2,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974252,
				"year": "2025",
				"quotesDate": "2025-02-12",
				"quote": "1000000.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-4.260140052",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974253,
				"updated_at": 1739974259
			},
			{
				"id": 2,
				"portfolio_id": 2,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974256,
				"year": "2025",
				"quotesDate": "2025-02-11",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 3,
				"portfolio_id": 2,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974254,
				"year": "2025",
				"quotesDate": "2025-02-10",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 1,
				"portfolio_id": 3,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974252,
				"year": "2025",
				"quotesDate": "2025-02-12",
				"quote": "1000000.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-4.260140052",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974253,
				"updated_at": 1739974259
			},
			{
				"id": 2,
				"portfolio_id": 3,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974256,
				"year": "2025",
				"quotesDate": "2025-02-11",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
			{
				"id": 3,
				"portfolio_id": 3,
				"currency": "RUB",
				"managementFee": "0.0000000000",
				"request_datetime": 1739974254,
				"year": "2025",
				"quotesDate": "2025-02-10",
				"quote": "1044490.18999999996",
				"nav": "10444918.73999999946",
				"quote_previous_day": "-2.851789021",
				"nav_previous_day": "0.0000000000",
				"created_at": 1739974256,
				"updated_at": 1739974259
			},
		]
	}
	const content = document.getElementById('content')


// Добавляем анимацию загрузки
	const loader = document.createElement('div');
	loader.classList.add('loading-animation');
	createLoadingRing(loader)
	content.appendChild(loader);

	Promise.all([$Api.getPortfolios(), $Api.getParams()])
		.then(([portfoliosRes, paramsRes]) => {
			if (portfoliosRes.success && paramsRes.success) {
				portfeles = portfoliosRes.data;
				params = paramsRes.data;
				loader.remove(); // Убираем анимацию загрузки после получения данных
				renderContent(); // Вызываем функцию для рендеринга контента
			}
		})
		.catch(error => {
			// loader.remove(); // Убираем анимацию загрузки после получения данных
			// renderContent(); // Вызываем функцию для рендеринга контента
			loader.textContent = 'Ошибка загрузки данных';
		})
	function createLoadingRing(container) {
		const canvas = document.createElement("canvas");
		canvas.width = 100;
		canvas.height = 100;
		container.appendChild(canvas);
		const ctx = canvas.getContext("2d");
		let angle = 0;

		function draw() {
			ctx.clearRect(0, 0, canvas.width, canvas.height);
			ctx.save();
			ctx.translate(canvas.width / 2, canvas.height / 2);
			ctx.rotate(angle);
			ctx.beginPath();
			ctx.arc(0, 0, 30, 0, Math.PI * 1.5);
			ctx.lineWidth = 6;
			ctx.strokeStyle = "#15b015";
			ctx.lineCap = "round";
			ctx.stroke();
			ctx.restore();
			angle += 0.05;
			requestAnimationFrame(draw);
		}
		draw();
	}

	function formatYear(createdAt, year) {
		if (!createdAt || isNaN(createdAt)) return `01.01.${year} 12:00`;
		const date = new Date(createdAt * 1000);
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		return `${day}.${month}.${year} ${hours}:${minutes}`;
	}

	function formatQuotesDate(dateStr) {
		if (!dateStr) return "01.01.1970";
		const parts = dateStr.split("-");
		if (parts.length === 3) {
			return `${parts[2]}.${parts[1]}.${parts[0]}`;
		}
		return dateStr;
	}

	function renderContent() {


		portfeles.forEach(portfolio => {
			const tabsContainer = document.createElement('div');
			tabsContainer.classList.add('ns-tabs-new', 'js-tabs', 'mt-38');
			tabsContainer.setAttribute('data-tab-name', 'ns-biletPrograms');

			const tabsList = document.createElement('div');
			tabsList.classList.add('ns-tabs-new__list', 'ns-insurance__tabs-list');

			const tabsContent = document.createElement('div');
			tabsContent.classList.add('ns-tabs-new__content');

			Object.keys(params).forEach((year, index) => {
				const yearData = params[year].filter(item => item.portfolio_id === portfolio.id);
				if (yearData.length > 0) {
					const tabName = document.createElement('div');
					tabName.classList.add('ns-tabs-new__name', 'js-tabs-name');
					tabName.setAttribute('data-tab-index', index);
					tabName.textContent = year;
					if (index === 0) tabName.classList.add('active', 'old-document-show-second');
					else tabName.classList.add('old-document-show');

					const tabContent = document.createElement('div');
					tabContent.classList.add('ns-tabs-new__item', 'js-tabs-item');
					tabContent.style.display = index === 0 ? 'block' : 'none';

					const tableContainer = document.createElement('div');
					tableContainer.classList.add('blockDrop__scroll');

					const tableGrid = document.createElement('div');
					tableGrid.classList.add('block__gridlist-2', 'block__gridlist__top');

					const tableHeader = document.createElement('div');
					tableHeader.classList.add('block__inform-content', 'block__gridlist-content-5');
					tableHeader.innerHTML = `
					<p class="ns-text ns-text--fs-14-600">Дата и время публикации на сайте</p>
					<p class="ns-text ns-text--fs-14-600">Дата расчета</p>
					<p class="ns-text ns-text--fs-14-600">Стоимость пая</p>
					<p class="ns-text ns-text--fs-14-600">СЧА</p>
					<p class="ns-text ns-text--fs-14-600">Изменение стоимости пая к предыдущей дате</p>
					<p class="ns-text ns-text--fs-14-600">Изменение стоимости СЧА к предыдущей дате</p>
				`;
					tableGrid.appendChild(tableHeader);

					yearData.forEach(entry => {
						const formatNumber = function(num) {
							const parsed = parseFloat(num);
							if (isNaN(parsed)) return '---';

							return parsed
								.toFixed(2)
								.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
						};
						const row = document.createElement('div');
						row.classList.add('block__inform-content', 'block__gridlist-content-5');
						row.innerHTML = `
						<p class="ns-text ns-text--fs-14">${formatYear(entry.created_at, entry.year)}</p>
						<p class="ns-text ns-text--fs-14">${formatQuotesDate(entry.quotesDate)}</p>
						<p class="ns-text ns-text--fs-14">${formatNumber(entry.quote)}</p>
						<p class="ns-text ns-text--fs-14">${formatNumber(entry.nav)}</p>
						<p class="ns-text ns-text--fs-14">${entry.quote_previous_day != null ? formatNumber(entry.quote_previous_day) : "---"}%</p>
						<p class="ns-text ns-text--fs-14">${entry.nav_previous_day != null ? formatNumber(entry.nav_previous_day) : "---"}%</p>
					`;
						tableGrid.appendChild(row);
					});

					tableContainer.appendChild(tableGrid);
					tabContent.appendChild(tableContainer);
					tabsList.appendChild(tabName);
					tabsContent.appendChild(tabContent);
				}
			});

			tabsContainer.appendChild(tabsList);
			tabsContainer.appendChild(tabsContent);
			content.appendChild(tabsContainer);
		});

	}
	const $tripleDropdownList = document.querySelectorAll('.js-tripleDropdown');
	$tripleDropdownList.forEach((dropdown) => {
		new tripleDropdown(dropdown);
	});

	const $tabs = document.querySelectorAll('.js-tabs');
	$tabs.forEach((tab) => {
		new Tabs(tab);
	});

	const $doubleDropdownList = document.querySelectorAll('.js-doubleDropdown');
    const $dropdownList = document.querySelectorAll('.js-dropdown');
    const categoryLink = document.getElementsByClassName('js-category');
    const financialMetrics = document.getElementById('financial_metrics');
    const documentation = document.getElementById('ins_documentation');
    const policyActions = document.getElementById('policy_actions');
	const $lineTabs = document.querySelectorAll('.js-line-tabs');


	var hash = window.location.hash.substring(1);
	for(var i=0; i < categoryLink.length; i++) {
		categoryLink[i].addEventListener('click', function() {

			setTimeout(() => {
				hash = window.location.hash.substring(1);
				if (hash && document.getElementById(hash)) {
					// Добавляем класс 'active' к элементу с идентификатором из URL
					document.getElementById(hash).classList.add('active');
					document.getElementById(hash).querySelector('.js-dropdown__content').style.display = 'block'
				}
			}, 100)

		});
	}
	// Проверяем, существует ли элемент с соответствующим идентификатором
	if (hash && document.getElementById(hash)) {
		// Добавляем класс 'active' к элементу с идентификатором из URL
		document.getElementById(hash).classList.add('active');
	} else {
		setTimeout(() => {
				financialMetrics.classList.add('active');
				financialMetrics.querySelector('.js-dropdown__content').style.display = 'block'
				documentation.classList.add('active');
				documentation.querySelector('.js-dropdown__content').style.display = 'block'
				policyActions.classList.add('active');
				policyActions.querySelector('.js-dropdown__content').style.display = 'block'
		}, 100)

	}


	$dropdownList.forEach((dropdown) => {
		new Dropdown(dropdown);
	});

	$doubleDropdownList.forEach((dropdown) => {
        new doubleDropdown(dropdown);
    });


	$lineTabs.forEach((tab) => {
		new NewTabs(tab);
	});
	const button = document.querySelector('.b-footer__agreement_link2');
	button.addEventListener('click', function() {
		button.classList.toggle('active');
	});


	console.log(111, 'client init');
})();
